<form [formGroup]="form" autocomplete="off" class="form-horizontal">
  <div class="form-row mb-5x">
    <input
      class="form-check-input"
      datevMessagePath="isKStUndGewStOrgangesellschaft{{objectId}}"
      formControlName="isKStUndGewStOrgangesellschaft"
      id="isKStUndGewStOrgangesellschaft{{index}}"
      type="checkbox" utilsCheckValidity
      utilsControlState
      utilsValidationMessage>
    <label class="form-check-label" for="isKStUndGewStOrgangesellschaft{{index}}">
      {{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.IST_KST_UND_GEWST_ORGANGESELLSCHAFT' | translate }}
    </label>
  </div>
  <div class="form-row">
    <label class="col-sm-4 col-form-label"
           for="datumGewinnAbfVertrag{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANGESELLSCHAFT.DATUMGEWINNABFVERTRAG' | translate }}</label>
    <div class="col-sm-8">
      <date-picker
              id="datumGewinnAbfVertrag{{index}}"
              messagePath="datumGewinnAbfVertrag{{objectId}}"
              formControlName="datumGewinnAbfVertrag" utilsMarkRequired>
      </date-picker>
    </div>
  </div>
</form>
